/**
 * Configuration for the Header Mega-Menu ("Categories")
 * Easily add or modify categories, sub-routes, badges, icons, and featured promotional cards.
 */

export const categoriesMenuConfig = {
  featuredCard: {
    badge: "What's new",
    title: "We've just released an update!",
    subtitle: "Learn about our new UI and features.",
    description: "Real-time analytics, campaign automation, and omni-channel casino engine.",
    buttonText: "Version 2.4",
    targetSection: "slot",
    targetRouteName: "Home",
  },
  categories: [
    {
      id: "slot",
      title: "SLOT",
      section: "slot",
      description: "Slot engine, campaigns & player tools",
      icon: "fa-solid fa-gem",
      badge: null,
      items: [
        {
          name: "Dashboard",
          label: "Dashboard",
          routeName: "Home",
          icon: "fa-solid fa-house",
          description: "Slot overview & live metrics",
          badge: null,
        },
        {
          name: "Freebets",
          label: "Freebets",
          routeName: "Freebets",
          icon: "fa-solid fa-ticket",
          description: "Standalone freebets & claimed rewards from promotions",
          badge: null,
        },
        {
          name: "Promotions",
          label: "Promotions Hub",
          routeName: "Promotions",
          icon: "fa-solid fa-bullhorn",
          description: "Unified promotions & campaign center",
          badge: { text: "All-in-one", type: "primary" },
        },
        {
          name: "LoyaltyCoins",
          label: "Loyalty Coins",
          routeName: "LoyaltyCoins",
          icon: "fa-solid fa-coins",
          description: "Coins accumulation & gameplay tasks",
          badge: { text: "New", type: "accent" },
        },
        {
          name: "Players",
          label: "Players",
          routeName: "Players",
          icon: "fa-solid fa-users",
          description: "Search & view player history",
          badge: null,
        },
        {
          name: "Chat",
          label: "Chat",
          routeName: "ChatPage",
          icon: "fa-solid fa-comments",
          description: "Community chat monitoring",
          badge: null,
        },
        {
          name: "Export",
          label: "Export",
          routeName: "ExportPage",
          icon: "fa-solid fa-file-export",
          description: "Download data & reports",
          badge: null,
        },
      ],
    },
    {
      id: "livecasino",
      title: "LIVE CASINO",
      section: "livecasino",
      description: "Real-time tables, dealers & interactive rounds",
      icon: "fa-solid fa-dice",
      badge: { text: "", type: "primary" },
      items: [
        {
          name: "Dashboard",
          label: "Dashboard",
          routeName: "LiveCasinoHome",
          icon: "fa-solid fa-house",
          description: "Live casino overview & tables",
          badge: null,
        },
        {
          name: "Extractions",
          label: "Extractions",
          routeName: "LiveCasinoExtractionsPage",
          icon: "fa-solid fa-table-cells",
          description: "Live roulette winning number extractions",
          badge: null,
        },
        {
          name: "Spins",
          label: "Spins",
          routeName: "LiveCasinoSpinsPage",
          icon: "fa-solid fa-rotate",
          description: "Live table player bets & roulette spins",
          badge: null,
        },
        {
          name: "Chat",
          label: "Chat",
          routeName: "LiveCasinoChatPage",
          icon: "fa-solid fa-comments",
          description: "Table player communications",
          badge: null,
        },
        {
          name: "Export",
          label: "Export",
          routeName: "LiveCasinoExportPage",
          icon: "fa-solid fa-file-export",
          description: "Live casino reports & logs",
          badge: null,
        },
        {
          name: "Players",
          label: "Players",
          routeName: "LiveCasinoPlayersPage",
          icon: "fa-solid fa-users",
          description: "Search & view player history",
          badge: null,
        },
      ],
    },
    {
      id: "instant",
      title: "INSTANT",
      section: "instant",
      description: "Fast multipliers, crash games & speed rounds",
      icon: "fa-solid fa-bolt-lightning",
      badge: { text: "", type: "warning" },
      items: [
        {
          name: "Dashboard",
          label: "Dashboard",
          routeName: "InstantHome",
          icon: "fa-solid fa-house",
          description: "Instant games dashboard",
          badge: null,
        },
      ],
    },
    {
      id: "crash",
      title: "CRASH",
      section: "crash",
      description: "Crash multipliers & fast-paced games",
      icon: "fa-solid fa-plane-departure",
      badge: { text: "", type: "danger" },
      items: [
        {
          name: "Crash Games",
          label: "Crash Games",
          icon: "fa-solid fa-plane-departure",
          description: "Go to Crash Games Platform",
          isExternal: true,
          badge: null,
        },
      ],
    },
  ],
};

/**
 * Helper to build route location preserving active language and skin filter
 */
export function buildNavigationRoute(item, route, store) {
  const currentLang = route?.params?.lang || localStorage.getItem("locale") || "en";
  const skinFilt =
    route?.params?.skinFilt ||
    store?.getters?.skinStorage ||
    store?.state?.skinStorage ||
    (store?.getters?.isAdmin ? "" : store?.getters?.allowedSkins?.[0]?.ref_id || "");

  const params = { lang: currentLang };
  if (skinFilt && skinFilt !== "all") {
    params.skinFilt = skinFilt.toString();
  }

  return {
    name: item.routeName,
    params,
  };
}
